import { createRoutine } from 'redux-saga-routines';

export const roadGraphCatalogReadRoutine = createRoutine('ROAD_GRAPH/READ_CATALOG');
